import { useTranslation } from 'react-i18next'

import { Badge, type BadgeProps } from '@enechain/ecloud-designsystem'

import { HintTooltip } from '~/components/common/HintTooltip'
import { useMemberDisplayName } from '~/hooks/member/useMemberDisplayName'
import { formatJstDateTimeHm } from '~/models/dateTime'
import { STATUS_I18N_KEY } from '~/pages/CustomerInfo/models/display'
import type {
  ContractStatus,
  SupplyPoint,
} from '~/pages/CustomerInfo/models/types'

/** 状態 → Badge の色。 モックの契約一覧と同じ割り当て。 */
const STATUS_BADGE: Record<ContractStatus, BadgeProps['status']> = {
  prospect: 'info',
  lost: 'neutral',
  supplying: 'positive',
  starting: 'info',
  ending: 'warning',
  ended: 'neutral',
}

type Props = {
  status: ContractStatus
  /** 失注の時だけ hover で失注日時・失注者を出す。 */
  point?: Pick<SupplyPoint, 'lostAt' | 'lostBy'>
}

export const ContractStatusBadge = ({
  status,
  point,
}: Props): React.ReactElement => {
  const { t } = useTranslation()
  const none = t('page:customerInfo.common.none')
  const resolveMemberName = useMemberDisplayName()
  const tooltip =
    status === 'lost'
      ? t('page:customerInfo.status.lostTooltip', {
          at:
            point?.lostAt === undefined
              ? none
              : formatJstDateTimeHm(point.lostAt),
          by: resolveMemberName(point?.lostBy) ?? none,
        })
      : undefined
  return (
    <HintTooltip content={tooltip}>
      <span>
        <Badge status={STATUS_BADGE[status]}>
          {t(STATUS_I18N_KEY[status])}
        </Badge>
      </span>
    </HintTooltip>
  )
}
